import { getAppContext } from '@/app/context'
import { AppInstance, AppMountTarget } from '@/app/instance'
import { IAppApplication } from '@/app/application'
import { AppFramework, configureAppFramework, getAppFramework } from '@/app/framework'

let isConfigured = false

export function configureVueApp(): void {
  if (isConfigured) return

  const context = getAppContext()
  const framework: AppFramework = getAppFramework()

  configureAppFramework(framework, context)

  isConfigured = true
}

export function createVueApp(): IAppApplication {
  configureVueApp()

  return getAppFramework()
}

export function mountVueApp(target: AppMountTarget = '#app'): AppInstance {
  return createVueApp().mount(target)
}
